import {
  BrandAndMarketListItem,
  CodeAndLabel,
  DateTimeRestrictionData,
  FormDataRouteRestriction,
  RuleFormDataAgencyOrGroup,
  SearchTravelRange,
} from "../../../integrated-client/models";

export interface ISearchManagerV2EditorData {
  id?: string | null;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  relevance?: number;
  maxPriceSolutions?: number | null;
  maxPricePoints?: number | null;
  dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  dateTimeRestrictionsTimeZone?: CodeAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannels?: Array<number> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  salesJourneys?: Array<string> | null;
  cloneSourceId?: string | null;
  travelDates?: Array<SearchTravelRange> | null;
  allowEdit?: boolean;
}

export interface IEditorData {
  searchManagerEditorData: ISearchManagerV2EditorData;
  validation?: any;
}

export class SearchManagerV2EditorData implements ISearchManagerV2EditorData {
  id?: string | null;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  relevance?: number;
  maxPriceSolutions?: number | null;
  maxPricePoints?: number | null;
  dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  dateTimeRestrictionsTimeZone?: CodeAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannels?: Array<number> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  salesJourneys?: Array<string> | null;
  cloneSourceId?: string | null;
  travelDates?: Array<SearchTravelRange> | null;
  allowEdit?: boolean;

  constructor() {
    this.disabled = false;
  }
}

export class EditorData implements IEditorData {
  searchManagerEditorData: ISearchManagerV2EditorData;
  validation?: any;

  constructor() {
    this.searchManagerEditorData = new SearchManagerV2EditorData();
  }
}
